<div class="dots">
  @for (n of indices; track n) {
    <!-- `aria-current` rather than `aria-selected`: these are not tabs, they are
         a position indicator you may also click. The source uses the same. -->
    <button
      class="dots__dot"
      type="button"
      [class.dots__dot--on]="n === current"
      [attr.aria-current]="n === current"
      [attr.aria-label]="labelFor(n)"
      (click)="jump.emit(n)"
    ></button>
  }
</div>
